import HelpfulLink_vue_vue_type_script_setup_true_lang_default from "./HelpfulLink.vue_vue_type_script_setup_true_lang.js";
//#region src/components/HelpfulLink.vue
var HelpfulLink_default = HelpfulLink_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { HelpfulLink_default as default };

//# sourceMappingURL=HelpfulLink.vue.js.map